import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import LoadingComponent from '../../../app/layout/LoadingComponents'
import { useStore } from '../../../app/stores/ardstore'
import ArduinoList from './ArduinoList'

export default observer(function ArduinoDashboard () {
  const { arduinoStore } = useStore()
  const { loadArduinos, arduinoRegistry } = arduinoStore
  useEffect(() => {
    if (arduinoRegistry.size <= 0) { loadArduinos() }
  }, [arduinoStore, arduinoRegistry.size, loadArduinos])

  if (arduinoStore.loadingInitial) {
    return <LoadingComponent content="Loading app" />
  }

  return <ArduinoList arduinoStore={arduinoStore} />
})
